<template>
  <v-container class="fill-height text-start" style="opacity: 0.94" fluid>
    <v-sheet elevation="1" rounded width="100%" class="mt-16 mb-8" height="90vh">
      <deprecation-banner />
      <v-toolbar rounded class="mb-5">
        <h2>Fingerprint Extractor</h2>
      </v-toolbar>
      <v-row justify="space-around" class="py-5 px-12">
        <v-col cols="4" class="text-end">
          <v-form>
            <v-checkbox label="Compress Image" v-model="compressImage"></v-checkbox>
            <v-slider
              label="Image Quality"
              v-model="uploadQuality"
              :disabled="!compressImage"
              min="0"
              max="1"
              step="0.1"
              thumb-label
            ></v-slider>
            <v-checkbox label="Smooth" v-model="data.smooth"></v-checkbox>
            <v-slider
              label="Details"
              v-model="data.details"
              min="0"
              max="10"
              step="1"
              thumb-label
            ></v-slider>
            <v-slider
              label="Sigma"
              v-model="data.sigma"
              min="0.00"
              max="0.99"
              step="0.05"
              thumb-label
            ></v-slider>
            <v-checkbox label="Thin" v-model="data.thin"></v-checkbox>
            <v-slider
              :disabled="!data.thin"
              label="Thickness"
              v-model="data.thickness"
              min="0"
              max="2"
              step="1"
              thumb-label
            ></v-slider>
            <v-btn :loading="loading" @click="generateFingerprint" color="primary">
              <template #loader>
                <span class="custom-loader">
                  <v-icon light>mdi-cached</v-icon>
                </span>
              </template>
              Save & Preview
            </v-btn>
          </v-form>
        </v-col>
        <v-col cols="8">
          <v-list outlined nav>
            <v-subheader>Preview</v-subheader>
            <v-row>
              <v-col cols="6">
                <image-upload @change="handleImageSelected" />
              </v-col>
              <v-col cols="6" style="position: relative">
                <v-btn
                  fab
                  style="position: absolute; z-index: 9999; right: 20px; top: 20px"
                  small
                  @click="downloadImage"
                >
                  <v-icon>mdi-cloud-download-outline</v-icon>
                </v-btn>
                <v-img :src="previewSrc" />
              </v-col>
            </v-row>
          </v-list>
        </v-col>
      </v-row>
    </v-sheet>
  </v-container>
</template>

<script>
  import swh from '@/assets/js/sw_helper'
  import utils from '@/assets/js/utils'
  import ImageUpload from '../components/ImageUpload.vue'
  import DeprecationBanner from '../components/DeprecationBanner.vue'
  import axios from 'axios'
  import imageResize from 'image-resize'

  export default {
    props: {
      source: String,
    },
    data() {
      return {
        compressImage: false,
        uploadQuality: 1,
        previewOriginal: 'https://placehold.co/200x300',
        previewSrc: 'https://placehold.co/200x300',
        loading: false,
        selectedImage: null,
        data: {
          file: null,
          smooth: false,
          details: 5,
          sigma: 0.5,
          thin: false,
          thickness: 10,
        },
        apiUrl: `${process.env.VUE_APP_MIZODIA_API_SERVER}/`,
      }
    },
    methods: {
      handleImageSelected(file) {
        if (file) {
          this.selectedImage = file
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewOriginal = e.target.result
          }
          reader.readAsDataURL(file)
        }
      },
      getImageSrc(color, version) {
        const img = utils.getCoverImageSrc(color, version)
        return img
      },
      getBlobSizeInMB(blob) {
        const sizeInBytes = blob.size
        const sizeInMB = sizeInBytes / (1024 * 1024) // Convert bytes to MB
        return sizeInMB.toFixed(2) // Return size in MB rounded to two decimal places
      },
      async resizeImage(image, quality) {
        console.log(quality)

        return imageResize(image, { quality, sharpen: 0, outputType: 'blob' })
      },
      async generateFingerprint() {
        this.loading = true
        try {
          // const config = {
          //   quality: this.uploadQuality,
          // }
          // const resizedBlob = await readAndCompressImage(this.selectedImage, config)
          const resizedBlob = this.compressImage
            ? await this.resizeImage(this.selectedImage, this.uploadQuality)
            : this.selectedImage

          const blobSizeInMB = this.getBlobSizeInMB(resizedBlob)
          console.log(`Blob size: ${blobSizeInMB} MB`)
          const formData = new FormData()
          Object.keys(this.data).forEach((key) => {
            formData.append(key, this.data[key])
          })
          formData.append('file', resizedBlob)

          let reqUrl = 'https://fingerprint-service.space-registry.org'
          const { data } = await axios.post(`${reqUrl}/process`, formData, {
            'Content-Type': 'multipart/form-data',
            responseType: 'blob',
          })

          const url = URL.createObjectURL(data)
          this.previewSrc = url
        } catch (err) {
          console.log(err)
        } finally {
          this.loading = false
        }
      },

      downloadImage() {
        // Create a download link
        const downloadLink = document.createElement('a')
        downloadLink.href = this.previewSrc
        downloadLink.download = 'fingerprint.jpg'
        downloadLink.click()
      },
    },

    watch: {
      date() {
        this.data.birthDate = swh.formatDate(this.date)
        console.log(this.date)
      },
    },
    components: { ImageUpload, DeprecationBanner },
  }
</script>

<style scoped>
  .centered-input >>> input {
    text-align: center;
  }

  .custom-loader {
    transform: scaleX(-1);
    -moz-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    -ms-transform: scaleX(-1);
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
